import * as React from 'react';
const ProductPageSetTile = ({ product, linkTextCard }) => {
  // add slash at the beginning of
  const addSlash = (url) => {
    return url.charAt(0) !== '/' ? '/' + url : url;
  };
  return (
    <div className="flex flex-col items-start product-page-set-item my-6 space-y-4">
      {product.images.length > 0 && (
        <a href={addSlash(product.url)} className="image-wrapper w-full">
          <img
            src={product.images[0].url}
            alt={`Image of ${product.title}`}
            className="w-full h-full object-contain"
          />
        </a>
      )}
      {product.seo.title && <h3 className="item-title text-left">{product.title}</h3>}
      <span>
        <a href={addSlash(product.url)} className="product-link" aria-label={`${linkTextCard} about ${product.title}`}>
          {linkTextCard}
        </a>
      </span>
    </div>
  );
};

export default ProductPageSetTile;
